export const getScrollTopOffset = () => {
    const subnav = document.querySelector('.m-Subnav');
    if (subnav && subnav.offsetHeight > 0) {
        return subnav.getBoundingClientRect().bottom;
    }
    const header = document.querySelector('.m-Header');
    return header ? header.offsetHeight : 0;
}